module.exports = __webpack_public_path__ + "static/img/new03.70b795c9.png";